import { useDispatch, useSelector } from 'react-redux'
import styles from './ChatPageV2.module.scss'
import { Avatar } from '@mui/material'
import { setCurrentSelectedUser } from '../../features/messageSlice'
import { getTimePassed } from '../../util/getTime'
import { useMemo } from 'react'

export const DirectChatList = ({
	closeSidebar,
	toggleSidebar,
	statusMap,
	searchQuery,
}) => {
	const dispatch = useDispatch()

	const currentSelectedUser = useSelector(
		(s) => s.message.currentSelectedUser
	)

	const rawList = useSelector((s) => s.message.directChatList)
	const onlineUsers = useSelector((s) => s.auth.onlineUsers)
	const userStatuses = useSelector((s) => s.auth.userStatuses)
	const role = useSelector((s) => s.kazooEvent.role)

	const filtered = useMemo(() => {
		const byTimeDesc = (a, b) => {
			const ta = a?.latestMessage?.createdAt ? new Date(a.latestMessage.createdAt).getTime() : 0
			const tb = b?.latestMessage?.createdAt ? new Date(b.latestMessage.createdAt).getTime() : 0
			return tb - ta
		}

		return rawList
			.filter((member) => !member.status)
			.slice()
			.sort(byTimeDesc)
	}, [rawList])

	const handleChatSelect = (chat) => {
		dispatch(setCurrentSelectedUser(chat))
		if (window.innerWidth <= 768) {
			closeSidebar()
		}
	}

	return (
		<ul className={styles.chatList}>
			{filtered.map((friend) => (
				<li
					key={friend._id}
					className={`${styles.chatItem} ${currentSelectedUser?._id === friend._id ? styles.selected : ''}`}
					onClick={() => handleChatSelect(friend) || toggleSidebar()}
				>
					<div
						className={`${styles.avatar} ${userStatuses[friend._id] === 'away'
							? styles.away
							: statusMap[onlineUsers.includes(friend._id)]
							}`}
					>
						<Avatar
							src={friend.profilePic}
							alt="avatar"
							className={styles.avatar__img}
						/>
					</div>

					<div className={styles.chatInfo}>
						<h4 className={styles.userName}>
							{friend.businessName ||
								friend.preferredName ||
								`${friend.firstName} ${friend.lastName}`}
						</h4>
						<p className={styles.lastMessage}>
							{friend.latestMessage?.fileUrl && !friend.latestMessage?.text ? (
								<>
									<span style={{ marginRight: '4px' }}>📄</span>
									Attachment
								</>
							) : (
								friend.latestMessage?.text
							)}
						</p>
					</div>
					<div className={styles.chatMeta}>
						{
							friend.latestMessage?.createdAt &&
							<span className={styles.timeStamp}>
								{getTimePassed(friend.latestMessage?.createdAt)}
							</span>
						}
						{friend.unreadCount > 0 && (
							<span className={styles.unreadBadge}>
								{friend.unreadCount > 99 ? '99+' : friend.unreadCount}
							</span>
						)}
					</div>
				</li>
			))}
		</ul>
	)
}
